import { Spinner } from 'react-bootstrap';

const Loading = () => {
  return (
    <div className='d-flex justify-content-center'>
      <Spinner variant='primary' animation='border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loading;
